import { render } from "./industryManage.vue?vue&type=template&id=18b1307a&ts=true"
import script from "./industryManage.vue?vue&type=script&lang=ts"
export * from "./industryManage.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__